var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowNextIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43667 10.7761L6.82958 5.87336C7.05681 5.66698 7.05681 5.33356 6.82958 5.12664L1.43667 0.223935C1.10865 -0.0746448 0.574948 -0.0746448 0.24634 0.223935C-0.081686 0.522514 -0.081686 1.0071 0.24634 1.30568L4.85968 5.50027L0.24634 9.69378C-0.081686 9.9929 -0.081686 10.4775 0.24634 10.7761C0.574948 11.0746 1.10865 11.0746 1.43667 10.7761Z",
    fill: "#4D4D4D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowNextIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowNextIcon.7e9c12cf.svg";
export { ForwardRef as ReactComponent };